import type { CSSProperties } from "react";
import type { TenantThemeVar } from "@sagot/constants";

/** Geometry custom properties for charts/meters, e.g. `--geo-width`, `--geo-x`. */
export type GeometryVar = `--geo-${string}`;
export type CssVarName = TenantThemeVar | GeometryVar;
export type CssVarMap = Partial<Record<CssVarName, string | number>>;

/**
 * The ONLY sanctioned way to set inline styles (CLAUDE.md rule 3): CSS custom properties for
 * tenant theming (`--wg-*`) and geometry (`--geo-*`). Consume them with arbitrary utilities,
 * e.g. `className="w-[var(--geo-width)]"` + `style={cssVars({ "--geo-width": "62%" })}`.
 */
export function cssVars(vars: CssVarMap): CSSProperties {
  const style: Record<string, string> = {};
  for (const [name, value] of Object.entries(vars)) {
    if (value === undefined) continue;
    style[name] = typeof value === "number" ? String(value) : value;
  }
  return style;
}
